import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from "chart.js"

Chart.register(...registerables)

export default class extends Controller {
  static values = {
    type: String,
    data: Object,
    options: Object
  }

  connect() {
    this.chart = new Chart(this.element, {
      type: this.typeValue || 'line',
      data: this.dataValue,
      options: this.optionsValue || this.defaultOptions()
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  defaultOptions() {
    return {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom',
        },
      },
    }
  }
}
